import type {
  CountMode,
  CountType,
  StockCountActivityItem,
  StockCountLine,
  StockCountReport,
  StockCountSession,
} from './stockCountTypes';
import type { StockCountView, WizardStep } from './stockCountTypes';
import type { ProductCategory } from '../../../domain/models';

/** Minimal product shape needed by the wizard perimeter step. */
export interface WizardProduct {
  id: string;
  name: string;
  sku: string;
  barcode?: string;
}

export interface WizardDraft {
  type: CountType;
  countMode: CountMode;
  categoryIds: string[];
  products: WizardProduct[];
  notes: string;
  thresholdUnits: number;
  thresholdPercent: number;
}

export interface StockCountViewModelState {
  view: StockCountView;
  sessions: StockCountSession[];
  sessionsPage: number;
  hasMoreSessions: boolean;
  activeSession: StockCountSession | null;
  selected: StockCountSession | null;
  lines: StockCountLine[];
  linesLoading: boolean;
  activity: StockCountActivityItem[];
  report: StockCountReport | null;
  categories: ProductCategory[];
  wizardStep: WizardStep;
  wizard: WizardDraft;
  wizardError: string;
  productSearch: string;
  productResults: WizardProduct[];
  productSearching: boolean;
  draftSession: StockCountSession | null;
  activeLineId: string | null;
  scanValue: string;
  keyMode: 'stock' | 'exposed';
  keyInput: string;
  lineError: string;
  showApproveModal: boolean;
  showForceSubmit: boolean;
  forceReason: string;
  showActivity: boolean;
  confirmCancelId: string | null;
  approveComment: string;
  acknowledgeHighVariance: boolean;
  isLoading: boolean;
  isSaving: boolean;
  notification: {
    message: string;
    type: 'success' | 'error' | 'info';
    show: boolean;
  };
}

export const initialWizardDraft = (): WizardDraft => ({
  type: 'full',
  countMode: 'dual',
  categoryIds: [],
  products: [],
  notes: '',
  thresholdUnits: 2,
  thresholdPercent: 2,
});

export const initialStockCountState = (): StockCountViewModelState => ({
  view: 'list',
  sessions: [],
  sessionsPage: 0,
  hasMoreSessions: false,
  activeSession: null,
  selected: null,
  lines: [],
  linesLoading: false,
  activity: [],
  report: null,
  categories: [],
  wizardStep: 1,
  wizard: initialWizardDraft(),
  wizardError: '',
  productSearch: '',
  productResults: [],
  productSearching: false,
  draftSession: null,
  activeLineId: null,
  scanValue: '',
  keyMode: 'stock',
  keyInput: '',
  lineError: '',
  showApproveModal: false,
  showForceSubmit: false,
  forceReason: '',
  showActivity: false,
  confirmCancelId: null,
  approveComment: '',
  acknowledgeHighVariance: false,
  isLoading: false,
  isSaving: false,
  notification: { message: '', type: 'info', show: false },
});
